"use client";

import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

import type { TabContentProps } from "@/components/shared/UniversalDetailPage/types/detailPage";
import type { Time_Entries } from "@/src/gql/graphql";

import { EditableTimeEntryDescription } from "./components/EditableTimeEntryDescription";
import { TimeEntryInformationSection } from "./components/TimeEntryInformationSection";
import { ApprovalStatusSection } from "./components/ApprovalStatusSection";
import { MetadataSection } from "./components/MetadataSection";

// Re-exported so the legacy TimeEntryDetails/DescriptionCard (and any other
// caller of the old module path) keeps importing the same editor unchanged.
export { EditableTimeEntryDescription } from "./components/EditableTimeEntryDescription";

/**
 * Time Entry Details Tab Component - Main Details Display
 *
 * Displays comprehensive time entry information including:
 * - Work description
 * - Time entry information (date, hours, entry type, billable rate, revenue)
 * - Approval status
 * - Metadata (created/updated timestamps)
 */
export function TimeEntryDetails({ item }: TabContentProps<Time_Entries>) {
  return (
    <div className="space-y-6">
      {/* Description Section */}
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Work Description</CardTitle>
        </CardHeader>
        <CardContent>
          <EditableTimeEntryDescription entryId={item.id} description={item.description} />
        </CardContent>
      </Card>

      {/* Time Entry Information */}
      <TimeEntryInformationSection item={item} />

      {/* Approval Status */}
      <ApprovalStatusSection item={item} />

      {/* Timestamps */}
      <MetadataSection item={item} />
    </div>
  );
}
